// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyCkDTRhNZWFQLV5I1IyQCILd2jqBw7LoQw",
    authDomain: "spending-tracker-8c622.firebaseapp.com",
    projectId: "spending-tracker-8c622",
    storageBucket: "spending-tracker-8c622.firebasestorage.app",
    messagingSenderId: "264592720044",
    appId: "1:264592720044:web:938003bad307defaad1f09",
    measurementId: "G-NR7S3RQ0XR"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { auth };
export default app;